<ngx-charts-pie-chart
  legendTitle=""
  labels="true"
  scheme="forest"
  [trimLabels]="false"
  (select)="onSelect($event)"
  doughnut="true"
  arcWidth=".5"
  legendPosition="below"
  legend="true"
  [results]="results">
  <ng-template #tooltipTemplate let-model="model">
    <div style="text-align: left">
      <div *ngFor="let data of results; let i = index">
        <p *ngIf="data.name === model.name">
          {{ data.name }}
        </p>
      </div>
    </div>
  </ng-template>
</ngx-charts-pie-chart>
